import FullHeight from './components/FullHeight'
import MagneticBtn from './components/MagneticBtn'
import SocialButtons from './components/SocialButtons'
import ArrowDown from './components/ArrowDown'
import Newsletter from './components/Newsletter'
import Press from './components/Press'
import Slideshow from './components/Slideshow'
import HeroBackground from './components/HeroBackground'
import Trailer from './components/Trailer'
import GaEvents from './components/GaEvents'

export class Main {
    constructor() {
        this.windowSizes = this.getWindowSizes()
        window.onresize = this
            .onResize
            .bind(this)

        this.init()
    }

    init() {
        this.initHeroBackground()
        this.initSlideshow()
        this.initFullHeight()
        //this.initMagneticBtn()
        this.initSocialButtons()
        this.initArrowDown()
        this.initNewsletter()
        this.initPress()
        this.initTrailer()
        this.initGA()
    }

    initHeroBackground() {
        this.heroBackground = new HeroBackground(this.windowSizes)
        this
            .heroBackground
            .init()
    }

    initGA() {
        const gaEvents = new GaEvents()

    }

    initSocialButtons() {
        const socialButtons = new SocialButtons()
        socialButtons.init()
    }

    initArrowDown() {
        this.arrowDown = new ArrowDown(this.windowSizes)
        this
            .arrowDown
            .init()
    }

    initMagneticBtn() {
        const magneticBtn = new MagneticBtn()
        magneticBtn.init()
    }

    initFullHeight() {
        this.fullHeight = new FullHeight(this.windowSizes)
        this
            .fullHeight
            .init()
    }

    initNewsletter() {
        const newsletter = new Newsletter()
        newsletter.init()
    }

    initPress() {
        this.press = new Press(this.windowSizes)
        this
            .press
            .init()
    }

    initSlideshow() {
        this.slideshow = new Slideshow(this.windowSizes)
        this
            .slideshow
            .init()
    }

    initTrailer() {
        this.trailer = new Trailer(this.windowSizes)
        this
            .trailer
            .init()
    }

    checkMobile() {
        const isMobile = {
            Android: function () {
                return navigator
                    .userAgent
                    .match(/Android/i);
            },
            BlackBerry: function () {
                return navigator
                    .userAgent
                    .match(/BlackBerry/i);
            },
            iOS: function () {
                return navigator
                    .userAgent
                    .match(/iPhone|iPad|iPod/i);
            },
            Opera: function () {
                return navigator
                    .userAgent
                    .match(/Opera Mini/i);
            },
            Windows: function () {
                return navigator
                    .userAgent
                    .match(/IEMobile/i) || navigator
                    .userAgent
                    .match(/WPDesktop/i);
            },
            any: function () {
                return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
            }
        };

        return isMobile.any()
    }

    getWindowSizes() {
        const width = window.innerWidth
        const height = window.innerHeight

        const mobile = width <= 414
            ? true
            : false
        const tablet = width <= 980 && width > 414
            ? true
            : false
        return {
            width: width,
            height: height,
            mobile: mobile,
            tablet: tablet,
            mobileDevice: this.checkMobile()
        }
    }

    onResize() {
        this.windowSizes = this.getWindowSizes()
        this
            .heroBackground
            .resize(this.windowSizes)
        this
            .fullHeight
            .resize(this.windowSizes)
        this
            .press
            .resize(this.windowSizes)
        this
            .slideshow
            .resize(this.windowSizes)
        this
            .trailer
            .resize(this.windowSizes)
        this
            .arrowDown
            .resize(this.windowSizes)
    }
}

//document.addEventListener("DOMContentLoaded", (e) => new Main());
export let main = new Main();


// WEBPACK FOOTER //
// ./src/js/index.js